import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Table } from "@opensea/ui-kit";
import { useIsFlowActive } from "../../flow/hooks/useIsFlowActive";
import { AcceptOffersSummary } from "../AcceptOffersSummary";
import { ReceiptDisplay } from "../Receipt";
import { QuoteReceiptFragment } from "./QuoteReceipt.fragment";
import { QuoteReceiptProvider } from "./QuoteReceiptProvider";
import { QuoteReceiptRow } from "./QuoteReceiptRow";
import { QuoteReceiptTotal } from "./QuoteReceiptTotal";
export const QuoteReceipt = t0 => {
  const $ = _c(17);
  const {
    initialPrices,
    quote: quoteKey,
    applyCreatorFee,
    onCreatorFeeChange,
    hidePricing
  } = t0;
  let t1;
  if ($[0] !== quoteKey) {
    t1 = readFragment(QuoteReceiptFragment, quoteKey);
    $[0] = quoteKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const quote = t1;
  const isAcceptOfferFlow = useIsFlowActive("accept-offer");
  let t2;
  if ($[2] !== quote.itemQuotes) {
    t2 = <Table itemKey={_temp} items={quote.itemQuotes} renderRow={QuoteReceiptRow} size="xl" />;
    $[2] = quote.itemQuotes;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const receipt = t2;
  let t3;
  if ($[4] !== applyCreatorFee || $[5] !== hidePricing || $[6] !== isAcceptOfferFlow || $[7] !== onCreatorFeeChange || $[8] !== quote) {
    t3 = hidePricing ? null : isAcceptOfferFlow ? <AcceptOffersSummary applyCreatorFee={applyCreatorFee} onCreatorFeeChange={onCreatorFeeChange} quote={quote} /> : <Table itemKey={_temp2} items={[quote.totalPrice]} renderRow={QuoteReceiptTotal} />;
    $[4] = applyCreatorFee;
    $[5] = hidePricing;
    $[6] = isAcceptOfferFlow;
    $[7] = onCreatorFeeChange;
    $[8] = quote;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const receiptTotal = t3;
  let t4;
  if ($[10] !== receipt || $[11] !== receiptTotal) {
    t4 = <ReceiptDisplay receipt={receipt} receiptTotal={receiptTotal} />;
    $[10] = receipt;
    $[11] = receiptTotal;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== hidePricing || $[14] !== initialPrices || $[15] !== t4) {
    t5 = <QuoteReceiptProvider hidePricing={hidePricing} initialPrices={initialPrices}>{t4}</QuoteReceiptProvider>;
    $[13] = hidePricing;
    $[14] = initialPrices;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
function _temp(quote_0) {
  return `${quote_0?.item.contractAddress}:${quote_0?.item.tokenId}`;
}
function _temp2(_, index) {
  return index;
}